/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCompanyRoomOutcomeConfigOptionFromJSON, StreemApiCompanyRoomOutcomeConfigOptionToJSON, } from './';
export function StreemApiCompanyRoomOutcomeConfigSectionFromJSON(json) {
    return StreemApiCompanyRoomOutcomeConfigSectionFromJSONTyped(json, false);
}
export function StreemApiCompanyRoomOutcomeConfigSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'options': !exists(json, 'options') ? undefined : (json['options'].map(StreemApiCompanyRoomOutcomeConfigOptionFromJSON)),
        'callSourceCodes': !exists(json, 'call_source_codes') ? undefined : json['call_source_codes'],
    };
}
export function StreemApiCompanyRoomOutcomeConfigSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'options': value.options === undefined ? undefined : (value.options.map(StreemApiCompanyRoomOutcomeConfigOptionToJSON)),
        'call_source_codes': value.callSourceCodes,
    };
}
//# sourceMappingURL=StreemApiCompanyRoomOutcomeConfigSection.js.map